import { FiUserCheck } from "react-icons/fi";
import { TbAdjustmentsExclamation, TbBuilding, TbChecks } from "react-icons/tb";

export const getStepsByType = (type: UserType) => {
  //@ts-ignore
  return setupWizard.filter((step) => step.types.includes(type));
};

export const nextStepByType = (type: UserType, currentKey: string) => {
  const steps = getStepsByType(type);
  const currentIndex = steps.findIndex((step) => step.key === currentKey);

  if (currentIndex === -1 || currentIndex + 1 >= steps.length) return null;
  return steps[currentIndex + 1].key;
};

export type UserType =
  (typeof SYSTEM_USER_TYPES)[keyof typeof SYSTEM_USER_TYPES];

export const SYSTEM_USER_TYPES = {
  FOUNDER: "FOUNDER",
  INVESTOR: "INVESTOR",
  DFI_GOVT: "DFI/GOVT",
  ACCELERATOR: "ACCELERATOR",
  ACADEMIA: "ACADEMIA",
  DEFAULT: "DEFAULT",
} as const;

export const SETUP_KEYS = {
  ACCOUNT: "account",
  CLAIM: "claim",
  PREFERENCES: "preferences",
  CONFIRMATION: "confirmation",
} as const;

export const setupWizard = [
  {
    icon: <TbAdjustmentsExclamation />,
    label: "Account",
    key: SETUP_KEYS.ACCOUNT,
    types: [
      SYSTEM_USER_TYPES.FOUNDER,
      SYSTEM_USER_TYPES.INVESTOR,
      SYSTEM_USER_TYPES.DFI_GOVT,
      SYSTEM_USER_TYPES.ACCELERATOR,
      SYSTEM_USER_TYPES.ACADEMIA,
      SYSTEM_USER_TYPES.DEFAULT,
    ],
  },
  {
    icon: <TbBuilding />,
    label: "Request for managing organisations",
    key: SETUP_KEYS.CLAIM,
    types: [
      SYSTEM_USER_TYPES.FOUNDER,
      SYSTEM_USER_TYPES.INVESTOR,
      SYSTEM_USER_TYPES.ACCELERATOR,
    ],
  },
  {
    icon: <FiUserCheck />,
    label: "Preferences",
    key: SETUP_KEYS.PREFERENCES,
    types: [
      // SYSTEM_USER_TYPES.FOUNDER,
      SYSTEM_USER_TYPES.INVESTOR,
      SYSTEM_USER_TYPES.DFI_GOVT,
      SYSTEM_USER_TYPES.ACCELERATOR,
      SYSTEM_USER_TYPES.ACADEMIA,
      SYSTEM_USER_TYPES.DEFAULT,
    ],
  },
  {
    icon: <TbChecks />,
    label: "Confirmation",
    key: SETUP_KEYS.CONFIRMATION,
    types: [
      SYSTEM_USER_TYPES.FOUNDER,
      SYSTEM_USER_TYPES.INVESTOR,
      SYSTEM_USER_TYPES.DFI_GOVT,
      SYSTEM_USER_TYPES.ACCELERATOR,
      SYSTEM_USER_TYPES.ACADEMIA,
      SYSTEM_USER_TYPES.DEFAULT,
    ],
  },
];
